import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { sendPasswordResetEmail } from 'firebase/auth';
import { Auth } from '@angular/fire/auth';
import { FooterComponent } from '../../components/footer/footer.component';
import { NavbarComponent } from '../../components/navbar/navbar.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

@Component({
   selector: 'forgot-password-page',
   standalone: true,
   imports: [FooterComponent, NavbarComponent, TranslateModule, FormsModule, RouterLink],
   templateUrl: './forgot-password-page.component.html',
   styleUrl: './forgot-password-page.component.scss',
})
export class ForgotPasswordPageComponent {
   currentSection = 'login';
   email = '';
   loading = false;
   errorKey = '';
   success = false;

   constructor(private auth: Auth) {}

   async sendResetEmail() {
      if (!this.email) return;
      this.loading = true;
      this.errorKey = '';
      this.success = false;
      try {
         await sendPasswordResetEmail(this.auth, this.email);
         this.success = true;
      } catch (e: any) {
         if (e.code === 'auth/user-not-found' || e.code === 'auth/invalid-email') {
            this.errorKey = 'pages.forgot-password-page.errorInvalidEmail';
         } else {
            this.errorKey = 'pages.forgot-password-page.errorGeneral';
         }
      } finally {
         this.loading = false;
      }
   }
}
